/**
 * @title BackInStockHelper.js: Sub-module
 * @description This JS file contains functions related to the back in stock
 *              functionalities
 * 
 */
define([], function() {

	var BackInStockHelper = {
		init : function() {
		},
		
		saveOOSNotificationRequest: function() {  
			$("#notify-me-btn").attr("disabled", true);
			var catentryId = $('#catEntryId').val();
			COSTCO.util.ajax({
		          type: 'GET',
		          url : 'AjaxManageBackInStockSubscriptionCmd?action=subscribe&catentryId='
						+ catentryId
						+ "&langId="
						+ wcs.langId
						+ "&catalogId="
						+ wcs.catalogId
						+ "&storeId=" + wcs.storeId,
		          done: function(data) {
		        	    var jsonData = JSON.parse(data);
		        	    if(jsonData.hasOwnProperty('success') && jsonData.success) {
		        	    	COSTCO.Product.showSuccessMessage(messages.PDETAIL_NOTIFY_ME_SUCCESS_MSG);
		        	    	$('.user-email span:nth-child(2) a').hide();
		        	    	$('.notify-me-btn-area').html('');
				  			$('.notify-me-btn-area').html(COSTCO.util.tmpl('tmpl_cancel_oos_notificaction', { }));
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								$('.oos-notify-me-v2 .success-notification')
									.html($('.notify-me-btn-area p').html())
									.removeClass('hide');
							} else {
								$('.oos-notify-me .text-area').html($('.notify-me-btn-area p').html());
							}
				  			$('.notify-me-btn-area p').remove();
		        	    }
		          },
		          timeout: wcs.ajaxTimeout,
		          fail: function(x, t, m) {
		            if (t === 'timeout') {
		              console.error('Error AJAX timeout.');
		            } else {
		              console.error('Unexpected AJAX error.');
		            }
		          }
		        }); 
		},
		cancelOOSNotificationRequest: function(e, userSubId) {  
			$("#cancel-notification-btn").attr("disabled", true);
			var catentryId = $('#catEntryId').val();
			COSTCO.util.ajax({
		          type: 'GET',
				  url : 'AjaxManageBackInStockSubscriptionCmd?action=unsubscribe&catentryId='
						+ catentryId
						+ "&langId="
						+ wcs.langId
						+ "&catalogId="
						+ wcs.catalogId
						+ "&storeId=" + wcs.storeId,
		          done: function(data) {
		        	    var jsonData = JSON.parse(data);
		        	    if(jsonData.hasOwnProperty('success') && jsonData.success) {
		        	    	COSTCO.Product.showSuccessMessage(messages.PDETAIL_NOTIFY_ME_SUCCESS_MSG);
		        	    	$('.user-email span:nth-child(2) a').show();
		        	    	$('.notify-me-btn-area').html('');
							$('.notify-me-btn-area').append(COSTCO.util.tmpl('tmpl_oos_notify_btn', { }));
							$('.oos-notify-me .text-area').html($('.notify-me-btn-area p').html());
				  			$('.notify-me-btn-area p').remove();
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								$('.oos-notify-me-v2 .success-notification').addClass('hide').empty();
							}
						}
		          },
		          timeout: wcs.ajaxTimeout,
		          fail: function(x, t, m) {
		            if (t === 'timeout') {
		              console.error('Error AJAX timeout.');
		            } else {
		              console.error('Unexpected AJAX error.');
		            }
		          }
		        });
		},
	}
	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}

	if (typeof window.COSTCO.Global == 'undefined') {
		document.addEventListener("CostcoGlobalLoaded", BackInStockHelper.init,
				false);
	} else {
		BackInStockHelper.init();
	}

	window.COSTCO.BackInStockHelper = BackInStockHelper;

});


// WEBPACK FOOTER //
// ./js/account/backinstock-helper.js